import styles from './style.module.css';

interface IMoneyInput {
  name: string;
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  onBlur?: () => void;
  label?: string | JSX.Element;
  placeholder?: string;
  errors?: string;
  prefix?: string;
}

const groupDigits = (digits: string) =>
  digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

export function MoneyInput({
  name,
  value,
  onChange,
  onBlur,
  label,
  placeholder,
  errors,
  prefix = 'R$',
}: IMoneyInput) {
  const display = value === undefined ? '' : groupDigits(String(value));
  const isValid = !errors && value !== undefined && value > 0;

  const handleChange = (raw: string) => {
    const digits = raw.replace(/\D/g, '');
    onChange(digits ? Number(digits) : undefined);
  };

  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <div className={styles.wrapper}>
        <input
          id={name}
          name={name}
          className={`${styles.input} ${isValid ? styles.inputValid : ''}`}
          type="text"
          inputMode="numeric"
          autoComplete="off"
          placeholder={placeholder}
          value={display ? `${prefix} ${display}` : ''}
          onChange={(event) => handleChange(event.target.value)}
          onBlur={onBlur}
        />
        {isValid && (
          <span className={styles.check}>
            <i className="material-icons-outlined">check_circle</i>
          </span>
        )}
      </div>
      <span className={styles.error}>{errors}</span>
    </>
  );
}
